import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { environment } from '@environments/environment';

import { TokenService } from './token.service';


// export function jwtInterceptor: HttpInterceptorFn = (req, next) => {

//   let clonedRequest = req.clone();
  
//   const tokenService = inject(TokenService);
  
//   const isLoggedIn = tokenService.authResponse() != undefined;
//   const isApiUrl = clonedRequest.url.startsWith(environment.apiUrl);
  
//   // if (isLoggedIn && (isApiUrl)) {
//   //   const currentUser = tokenService.authResponse()!;
//   //   clonedRequest = clonedRequest.clone({
//   //     withCredentials: true,
//   //     setHeaders: { Authorization: `Bearer ${currentUser.token}` }
//   //   });
//   // } else {
//   //   clonedRequest = clonedRequest.clone({
//   //     withCredentials: true
//   //   });
//   // }

//   return next(req).pipe(
//     tap(event => {
//     })
//   );

//   return next.handle(clonedRequest);
// }


export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  
  //const isLoggedIn = tokenService.authResponse() != undefined;
  const isApiUrl = req.url.startsWith(environment.apiUrl);

  const currentUser = tokenService.authResponse();
  if (currentUser?.token && isApiUrl) {
    const clonedReq = req.clone({
      withCredentials: true,
      headers: req.headers.set('Authorization', `Bearer ${currentUser.token}`)
    });
    return next(clonedReq);
  }

  return next(req);
};